import { colors } from '@fronton/tokens';
import clsx from 'clsx';
import { isNewTheme, passthrough, useStyleProps } from '../utils';
import styles from './styles.module.css';
export function overrideNewThemeVars(el) {
  const newThemeOverride = {
    '--background-secondary': '#F4F4F4',
    '--control-secondary': '#BFC3C3',
    '--control-minor': '#E0E1E2',
    '--control-hover-secondary': '#A5A9AA',
    '--control-hover-minor': '#BFC3C3',
    '--control-hover-accent': '#E79F26',
    '--success-primary': '#009F57',
    '--success-dark': '#006836',
    '--success-light': '#BEF4DC',
    '--brand-dark': '#BD7229',
    '--brand-light': '#FBE2A2',
    '--accent-light': '#F9EFBD',
    '--attention-primary': '#C33848',
    '--attention-dark': '#9C312A',
    '--attention-light': '#FFE1E4',
    '--b2b-primary': '#AE6849',
    '--b2b-dark': '#913300',
    '--b2b-light': '#E5CDC3',
    '--secondary-green-primary': '#88A99E',
    '--secondary-green-dark': '#5C8477',
    '--secondary-green-light': '#D5ECE3',
    '--secondary-blue-primary': '#1563C5',
    '--secondary-blue-dark': '#294877',
    '--secondary-blue-light': '#D5E8FF',
    '--secondary-purple-primary': '#992D7A',
    '--secondary-purple-dark': '#740354',
    '--secondary-purple-light': '#EDDEEA',
    '--secondary-yellow-light': '#F9EFBD',
    '--secondary-red-primary': '#CE0019',
    '--secondary-red-dark': '#8C030C',
    '--secondary-red-light': '#FFD7D4',
    '--service-primary': '#60A3BD',
    '--service-light': '#C2E5F4',
    '--font-base': `LMMain, Roboto, apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif`,
    '--font-title': `LMTitle, Roboto, apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif`,
    '--heading-letter-spacing': '0.25px',
    '--overline-letter-spacing': '0.6px',
    '--base-letter-spacing': '0.2px',
    '--overline-font-weight': '700',
    '--middle-font-weight': '600'
  };
  const isHasNewThemeCookie = isNewTheme();
  if (isHasNewThemeCookie && el) {
    Object.entries(newThemeOverride).forEach(([key, value]) => {
      el.style.setProperty(key, value);
    });
  }
}
export function useThemeProvider(props) {
  const {
    theme = 'light',
    override,
    children
  } = props;
  const predefinedTheme = predefinedThemes[theme];
  const themeIsClassName = typeof theme === 'string' && !predefinedTheme;
  const partialThemeIsClassName = typeof override === 'string';
  let {
    style
  } = useStyleProps({
    ...theme,
    ...(!override || partialThemeIsClassName ? {} : override)
  }, themeHandlers);
  const className = clsx(styles.themeProvider, styles.tokens, predefinedTheme, themeIsClassName && theme, partialThemeIsClassName && override);
  return {
    style,
    className,
    children
  };
}
const predefinedThemes = {
  light: styles.lightTheme
};
let themeHandlers = {};
for (const color of Object.keys(colors)) {
  themeHandlers[color] = [`--${color}`, passthrough];
}